const cols = [
  { title: "栏目导航", links: [{ t: "今日热榜", h: "#trending" }, { t: "事件时间线", h: "#timeline" }, { t: "主题分类", h: "#categories" }, { t: "常见问题", h: "#faq" }] },
  { title: "关于平台", links: [{ t: "关于我们", h: "#about" }, { t: "瓜讯订阅", h: "#subscribe" }, { t: "提交线索", h: "#about" }, { t: "回到顶部", h: "#top" }] },
];

export default function Footer() {
  return (
    <footer className="bg-accent-100/60 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg font-black text-background-50">
                瓜
              </span>
              <span className="font-heading text-xl font-extrabold tracking-tight text-foreground-950">
                吃瓜时间线
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              专注热点事件的全记录梳理。从爆发到发酵再到反转，帮你快速理清每起事件的完整脉络，看懂最新进展。
            </p>
            <p className="mt-4 text-xs text-foreground-500">内容整理基于公开报道与各方声明，具体以官方最终信息为准。</p>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-heading text-sm font-extrabold text-foreground-950">{c.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.t}>
                    <a href={l.h} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                      {l.t}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-foreground-200/40 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">© 2026 吃瓜时间线 · 一起把热闹看明白</p>
          <div className="flex items-center gap-1 text-foreground-500">
            <span className="text-xs">内容整理需谨慎甄别，请理性吃瓜</span>
          </div>
        </div>
      </div>
    </footer>
  );
}